/** Where the portal opens: what is in flight, and what can be started. */
import { api } from "../../lib/api.ts";
import { Link } from "../../lib/router.tsx";
import { useAsync } from "../../lib/useAsync.ts";
import { GuideInvite, PageHead, Tiles } from "../../components/Page.tsx";
import type { ApplicationRow, CatalogueEntry } from "./types.ts";

export function PortalOverview() {
  const applications = useAsync(() => api.get<{ applications: ApplicationRow[] }>("/api/applications"), []);
  const catalogue = useAsync(() => api.get<{ products: CatalogueEntry[] }>("/api/catalogue"), []);

  const rows = applications.data?.applications ?? [];
  const drafts = rows.filter((row) => row.status === "draft");
  const products = catalogue.data?.products ?? [];

  return (
    <div className="stack">
      <PageHead
        title="Dynamic Portal"
        sub="Applications are filled in against whatever the configuration studio has published."
      />

      <GuideInvite />

      <Tiles
        tiles={[
          { label: "In progress", value: drafts.length, tone: "warn" },
          { label: "Submitted", value: rows.filter((row) => row.status === "submitted").length, tone: "ok" },
          { label: "Products available", value: products.length, tone: "accent" },
          { label: "Questions across all", value: products.reduce((total, product) => total + product.fieldCount, 0), tone: "info" },
        ]}
      />

      <div className="card">
        <div className="card-head">
          <h2>Pick up where you left off</h2>
          <Link to="/applications">All applications →</Link>
        </div>
        {drafts.length === 0 ? (
          <div className="empty small">
            Nothing in progress. <Link to="/catalogue">Start an application</Link>.
          </div>
        ) : (
          <div className="table-wrap">
            <table className="table">
              <thead><tr><th>Reference</th><th>Product</th><th>Applicant</th><th>Last touched</th></tr></thead>
              <tbody>
                {drafts.slice(0, 6).map((row) => (
                  <tr key={row.id}>
                    <td><Link to={`/applications/${row.id}`}>{row.reference}</Link></td>
                    <td>{row.productName} <span className="small muted">v{row.version}</span></td>
                    <td>{row.label ?? <span className="muted">—</span>}</td>
                    <td className="small muted">{new Date(row.updatedAt).toLocaleString()}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
